import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import ReactSearchBox from 'react-search-box'

class SearchboxComp extends LoggedInPage{
    constructor(props){
        super(props);
        this.state={
            forceUpdater: 1            
        }
        this.lessons = this.processLessons(props.lessons) || []
    
        this.onSelect = this.onSelect.bind(this);
        this.onFocus = this.onFocus.bind(this);

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount(){
        super.componentDidMount();

        this.props.onRef(this);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
     this.wrapperRef = node;
    }

    handleClickOutside(event) {
        try{
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
               this.setState({forceUpdater: (this.state.forceUpdater + 1)});
            }
        }catch(e){
            console.error(e);
        }        
    }

    refresh(data = null){
        let lessonArr = [];
        if(data){
            lessonArr = this.processLessons(data);
            this.lessons = lessonArr;
        }
        
        this.setState({forceUpdater: (this.state.forceUpdater + 1)});
    }


    processLessons(lessons){
        if(lessons && lessons.length > 0){
            const me = this;
            let lessonData = [];
            lessons.map((lesson, ind) => {
                if(lesson){
                    lesson["key"] = (lesson.lessonname) ? lesson.lessonname.replace(/ /g,"").toLowerCase() : lesson.lessonname;
                    lesson["value"] = lesson.lessonname;

                    lessonData.push(lesson);
                }
            })

            return lessonData;
        }

        return null;
    }

    onFocus(lesson){
        
    }

    getFuseConfigs(){
        return {
            threshold: 0.15,
            minMatchCharLength: 10,
            keys: ['value'],
            location: 15
        }
    }

    onSelect(lesson){       
        if(!lesson || !lesson.lessonurl){
            return;
        }
        var lessonidTracking =  lesson.lessonid ||  lesson.lessonId;
        var lessonid =  lesson.lessonUrl ||  lesson.lessonurl;
        var lessonname =  lesson.lessonName ||  lesson.lessonname;
        var lurl =  lesson.lessonUrl || lesson.lessonurl;
        var lessonPref =  lesson.lessonType  ||  lesson.lessontype || "";
        var dd = !isNaN( lesson.preferredDdId) ?  lesson.preferredDdId : (!isNaN(lesson.lessondd) ? lesson.lessondd : 0);
        var accessId = !isNaN(lesson["classId"]) ? Number(lesson["classId"]) : 0;
        var classId = !isNaN(lesson["accessId"]) ? Number(lesson["accessId"]) : 0;
        const topicId = !isNaN(lesson["topicId"]) ? Number(lesson["topicId"]) : 0;
        const subTopicId = !isNaN(lesson["subTopicId"]) ? Number(lesson["subTopicId"]) : 0;
        const topicSubTopicMapId = !isNaN(lesson["topicSubTopicMapId"]) ? Number(lesson["topicSubTopicMapId"]) : 0;
        const lessonSrc = 4;

        let _url = "";
        if(lesson && lesson.lessontype === "mozart"){
            _url = "/mozartview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&accessId="+accessId+"&classId="+classId+"&lessonSrc="+lessonSrc+"&revisiontopicid="+topicSubTopicMapId;
        }else{
            _url = "/lessonview/"+lessonid+"?url="+lurl+"&lessonPref="+lessonPref+"&accessId="+accessId+"&classId="+classId+"&lessonSrc="+lessonSrc+"&revisiontopicid="+topicSubTopicMapId;
        }

       if(dd > 0){
         _url += "&dd="+dd;
       }
       window.open(_url,lessonid,'fullscreen=yes,menubar=no,width='+window.innerWidth+',height='+window.innerHeight).focus();

       this.setState({forceUpdater: this.state.forceUpdater+1});
    }

    render(){    	
    		return(
                <div className="landingContainer">
                    <div className="searchBox" ref={this.setWrapperRef}>
                        <ReactSearchBox 
                            key = {this.state.forceUpdater}
                            placeholder="Search lessons here"
                            value=""
                            inputBoxFontColor="#000"
                            inputBoxBorderColor ="#969696"
                            data={this.lessons}
                            onSelect = {this.onSelect}
                            onFocus = {this.onFocus}
                            callback={record => console.log("searchBox::", record)}
                            fuseConfigs = {this.getFuseConfigs()}
                        />
                    </div>
                </div>
        	)    	
    }
} 

export default SearchboxComp;


// WEBPACK FOOTER //
// ./src/views/plp/SearchboxComp.js